import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import commaNumber from 'comma-number';

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipContent = styled.div`
  position: absolute;
  background-color: #fff;
  color: #344054;
  padding: 5px 10px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px -2px #10182808;

  box-shadow: 0px 12px 16px -4px #10182814;

  font-size: 14px;
  pointer-events: none;
  opacity: ${({ visible }) => (visible ? '1' : '1')};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  top: ${({ position }) => (position === 'bottom' ? '100%' : 'auto')};
  bottom: ${({ position }) => (position === 'top' ? '100%' : 'auto')};
  left: 50%;
  transform: translateX(-50%);
  margin-top: ${({ position }) => (position === 'top' ? '10px' : '0')};
  margin-bottom: ${({ position }) => (position === 'bottom' ? '10px' : '10px')};
  white-space: nowrap;
  font-size: 12px;
  font-weight: 400;

  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #fff;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
  }

  span {
    font-weight: 500;
  }
`;

const Tooltip = ({ children, content, position }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  return (
    <TooltipWrapper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {children}
      <TooltipContent visible={isVisible} position={position}>
        <div>
          <div>
            Price by Bike:{' '}
            <span>
              {content.price_bike.currency.symbol}
              {commaNumber(content.price_bike.value)}
            </span>
          </div>
          {content.price_car.value > 0 && (
            <div>
              Price by Car:{' '}
              <span>
                {content.price_bike.currency.symbol}
                {commaNumber(content.price_car.value)}
              </span>
            </div>
          )}
          <div>
            Timeline:{' '}
            <span>
              {content?.eta}{' '}
              {content.eta.includes('days') || content.eta.includes('day')
                ? null
                : 'days'}
            </span>
          </div>
        </div>
      </TooltipContent>
    </TooltipWrapper>
  );
};

export default Tooltip;

Tooltip.propTypes = {
  content: PropTypes.object.isRequired,
  position: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
